interface ChipGroupProps {
  options: readonly string[];
  selected: string[];
  multi: boolean;
  /** `multi` only. Options beyond the cap disable rather than disappear. */
  max?: number;
  onChange: (next: string[]) => void;
}

/** Single and multi select, as chips. The only picker the flow uses. */
export default function ChipGroup({ options, selected, multi, max, onChange }: ChipGroupProps) {
  const atCap = multi && typeof max === 'number' && selected.length >= max;

  const toggle = (option: string) => {
    if (!multi) {
      onChange(selected[0] === option ? [] : [option]);
      return;
    }
    if (selected.includes(option)) onChange(selected.filter(item => item !== option));
    else if (!atCap) onChange([...selected, option]);
  };

  return (
    <div className="chips">
      {options.map(option => {
        const on = selected.includes(option);
        return (
          <button
            key={option}
            type="button"
            className="chip"
            aria-pressed={on}
            disabled={!on && atCap}
            onClick={() => toggle(option)}
          >
            {option}
          </button>
        );
      })}
    </div>
  );
}
